//empty array to store all divs that have an id
const pageAnchors = [];
const content = document.querySelector('.program-page-content')?.children || '';
//looping through each div and pushing the id into the array
for (let i = 0, len = content.length ; i < len; i++) {
        //checking if the div has an id
         if( content[i].attributes.id ) {
            //pushing the id into the array
            pageAnchors.push('#' + content[i].attributes.id.value)
         }
}

//looping through each anchor in the navbar and checking if it is in the array
const anchorList = document.querySelectorAll('.program-page-navbar li');
anchorList.forEach((item) => {
    //if the anchor is not in the array,f remove it from the navbar
    if(!pageAnchors.includes(item.children[0].attributes.href.value)) {
        item.remove();
    }
})


//sticky navbar on scroll
const navbar = document.querySelector('.program-page-navbar');
const sticky = navbar?.offsetTop

function stickyNav() {
    if (document.documentElement.scrollTop >= sticky) {
        navbar?.classList.add("program-page-navbar-scrolled")
    } else {
        navbar?.classList.remove("program-page-navbar-scrolled");
    }
}

window?.addEventListener('scroll', stickyNav);

const toggleDiv = document.getElementById("toggleDiv");
toggleDiv?.addEventListener("click", function() {
    document.getElementById("targetDiv").classList.toggle("toggleClass");
})
 
//close toggleDiv when link is clicked inside of it
const toggleLinks = document.querySelectorAll('.target-link');
toggleLinks.forEach((item) => {
    item.addEventListener('click', function() {
        document.getElementById("targetDiv").classList.remove("toggleClass");
    })
})
 

 